<template>
  <div class="contact_page centered_mid">
    <h1 class="contact_title" v-html="get_word('contact_us')"></h1>
    <form @submit.prevent="handleContact" class="contact_form">
      <div class="form_group">
        <label class="required form_label" for="name" v-html="get_word('_NAME_')"></label>
        <input required class="form_input" type="text" id="name" v-model="form.name" name="name" />
      </div>
      <div class="form_group">
        <label class="required form_label" for="email" v-html="get_word('_EMAIL_')"></label>
        <input required class="form_input" type="email" id="email" v-model="form.email" name="email" />
      </div>
      <div class="form_group">
        <label class="required form_label" for="phone" v-html="get_word('phone')"></label>
        <input required class="form_input" type="tel" id="phone" v-model="form.phone" name="phone" />
      </div>
      <div class="form_group">
        <label class="form_label" for="message" v-html="get_word('message')"></label>
        <textarea class="form_textarea" id="message" v-model="form.message" name="message"></textarea>
      </div>
      <div class="form_button_wrapper">
        <button class="form_button btn" type="submit" v-html="get_word('contact_me')"></button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
        form: {
            name: '',
            email: '',
            phone: '',
            message: '',            
        }
    };
  },
  methods: {
    handleContact(){
        this.api({ action: 'save_contact', method: 'post', data: this.form}, (data)=>{
            if(data.data === 'success'){
                Object.keys(this.form).forEach((key)=>this.form[key] = '');

                return this.$swal.fire({
                    icon: 'success',
                    html: this.get_word('thanks_for_contact'),
                    confirmButtonText: this.get_word('confirm')
                });
            }
        })
    }
  }
};
</script>

<style lang="scss" scoped>
.contact_page {
    @media (max-width: 600px) {padding: 15px;}
    @media (min-width: 600px) {padding: 30px;} 
}

.contact_title {color: #fff;margin-bottom: 10px;}

.contact_form {

  & > .form_group {
    margin-bottom: 1rem;

    .form_label, .form_input, .form_textarea, .form_button {
      display: block;
      width: 100%;
    }

    .form_label { margin-bottom: 0.5rem; color: #fff;}

    .form_input, .form_textarea {border-radius: 10px; padding: 0.5rem; border: none; margin-bottom: 0.5rem; background-color: #4F5861;outline: none;color: #fff;}

    .form_textarea{font-size: 20px;min-height: 100px;resize: none;}

    }

    .form_button {transition: all .25s;

        @media (max-width: 600px) {font-size: 20px;min-width: 100px;}
        @media (min-width: 600px) {min-width: 150px;font-size: 23px;}

        &:hover {background-color: darken(#dd1a7b, 10%);}
    }
    
    .form_button_wrapper{display: flex;
        @media (max-width: 600px) {justify-content: center;}
        @media (min-width: 600px) {justify-content: flex-end;}
    }
}
</style>